import { configUiPanel_mobile_horizontal as  configUiPanel_default} from "src/library/minigame_client/ui/cfg/mobile_horizontal/panel"

export let configUiPanel_mobile_horizontal = _.cloneDeep(configUiPanel_default);

configUiPanel_mobile_horizontal.sndBtnClick = "res/sounds/btn_click";
configUiPanel_mobile_horizontal.sndBtnPlay = "res/sounds/btn_click";
configUiPanel_mobile_horizontal.buttonPlaceBetPosition = {x: 742, y: 260};
configUiPanel_mobile_horizontal.balanceTabPosition = {x: 282, y: 1};
configUiPanel_mobile_horizontal.buttonPlaceBetText = 'PLACE A BET';
configUiPanel_mobile_horizontal.buttonPlaceBetTextScale = {x: 0.7, y: 0.9};


//////////////////
// WEBPACK FOOTER
// ./cfg/mobile_horizontal/panel.es6
// module id = 44
// module chunks = 0